exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-header[data-v-6e2edfb6]{background-color:#fef7ea}.modal-body[data-v-6e2edfb6]{font-size:.9rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-6e2edfb6&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modal/ChildDeleteConfirmModal.vue
// module id = 521
// module chunks = 0